<template>
    <section>
        <PageTitle title="All Riders" v-bind:crumbs="[{href:'/home',title:'Home'},{href:'/customers',title:'riders'}]" />
        <div class="wrapper wrapper-content animated fadeInRight">
            <div class="row">
                <div class="col-lg-12">
                    <div class="ibox-title">
                        <h5 class="pull-left">All Riders</h5>
                          <a v-if="userRole!=='ROLE_AGENT' && userRole!=='ROLE_BRANCH' && userRole!=='ROLE_USER' && userRole!=='ROLE_FRANCHISE'" v-on:click="loadEmptyCustomer()" class="pull-right" >Add New Riders</a>
                    </div>
                    <div class="ibox-content">
                        <div class="row" v-if="!isBranchUser">
                          <div class="col-md-3 form-group h-90">
                            <label>Contact Number</label>
                            <input placeholder="Enter Contact Number" id="contact" class="form-control custom_width" type="text" />
                          </div>
                          <div class="col-md-3 form-group h-90">
                            <label>Vehicle Number</label>
                            <input placeholder="Enter Vehicle Number" id="vehicle_number" class="form-control custom_width" type="text" />
                          </div>
                          <div class="col-md-3 form-group h-90">
                            <label>Rider Enabled</label>
                            <select id="enabled" class="form-control custom_width" v-model="isEnabled">
                              <option value="All">ALL</option>
                              <option value="No">NO</option>
                              <option value="Yes">YES</option>
                            </select>
                          </div>

                          <div class="col-md-3 form-group h-90">
                            <label>Contact No Verified</label>
                            <select id="contact_no_verified" class="form-control custom_width" v-model="isVerified">
                              <option value="All">ALL</option>
                              <option value="No">NO</option>
                              <option value="Yes">YES</option>
                            </select>
                          </div>
                            <div class="col-md-4">
                                <button style="margin-top: 25px;margin-right: 10px" class=" btn btn-primary btn-sm search_filter_order_btn"><i class="fa fa-search"></i> Search</button>
                                <button style="margin-top: 25px" class=" btn btn-info btn-sm refresh_filter_order_btn"><i class="fa fa-refresh"></i> Refresh</button>
                            </div>
                        </div>
                        <hr v-if="!isBranchUser"/>
                        <div class="table-responsive">
                            <table class="table table-striped table-responsive table-bordered table-hover" id="dtTable">
                                <thead>
                                    <tr>
                                        <th>Rider ID</th>
                                        <th>Name</th>
                                        <th>Contact</th>
                                        <th>Vehicle Number</th>
                                        <th>User Name</th>
                                        <th>Created</th>
                                        <th>Modified</th>
                                        <th>Enabled</th>
                                        <th>Verified</th>
                                        <th class="text-center" v-if="!isBranchUser"><i class="fa fa-bolt"></i></th>
                                    </tr>
                                </thead>
                                <tbody></tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ViewCustomerAddresses where="customers" ref="viewCustomerAddressPopUp"/>
        <AddUpdateRider ref="addUpdateRiderPopUp" />
        <UpdateUsersPassword ref="updateUserPasswordPopUp"/>
        <ViewAddUpdateRiderBranches ref="viewAddUpdateRiderBranchesRef"/>
    </section>
</template>

<script>
/* eslint-disable */
import PageTitle from '@/components/layout_components/PageTitle'
import ViewCustomerAddresses from '@/components/customers/ViewCustomerAddresses'
import AddUpdateRider from '@/components/riders/AddUpdateRider'
import ViewAddUpdateRiderBranches from '@/components/riders/ViewAddUpdateRiderBranches'
import Multiselect from 'vue-multiselect'
import UpdateUsersPassword from '@/components/users/UpdateUsersPassword'
import {deleteRider, toggleRider} from "@/api/riders";

export default {
      name: "Riders",
      components: {
        PageTitle,
        ViewCustomerAddresses,
        AddUpdateRider,
        Multiselect,
        ViewAddUpdateRiderBranches,
        UpdateUsersPassword
      },
      data() {
        return {
          selectedRestaurant: '',
          selectedBranch: '',
          restaurants: [],
          branches: [],
          table: '',
          userRole: '',
          isVerified: 'All',
          isEnabled: 'All',
        }
      },
      mounted() {
        let user = this.$store.state.user;
        this.userRole = user.userRolesById[0].role;
        if (this.userRole === 'ROLE_ADMIN' || this.userRole === 'ROLE_AGENT' || this.userRole ==='ROLE_MANAGER') {
          console.log("in admin");
          this.$http.post(this.$store.state.mainAppURL + "restaurants/get_all_restaurants").then(resp => {
            this.restaurants = resp.data;
          });
        } else if (this.userRole === 'ROLE_USER' || this.userRole === 'ROLE_FRANCHISE') {
          this.selectedRestaurant = this.$store.state.user.restaurant;
          this.restaurants.push({
            id: this.$store.state.user.restaurant.id,
            name: this.$store.state.user.restaurant.name
          });
          this.fetchBranchesOfRestaurant();
        }

        let self = this;
        const roleSuffix = this.userRole === 'ROLE_USER' || this.userRole === 'ROLE_BRANCH' || this.userRole === 'ROLE_FRANCHISE' ? 'V1/' : '';
        const processingURL = this.$store.state.mainAppURL + `riders/${roleSuffix}get_all_riders`;

        let dtTable = $('#dtTable').DataTable({
          "processing": true,
          "serverSide": true,
          "searching": true,
          "dom":'ltipr',
          autoWidth: false,
          "lengthMenu": [10, 25, 50, 100, 250],
          "order": [[0, "asc"]],
          'language': {
            //'loadingRecords': 'Please wait - loading...',
            'processing': '<div class="sk-spinner sk-spinner-double-bounce">\n' +
                '                <div class="sk-double-bounce1"></div>\n' +
                '                <div class="sk-double-bounce2"></div>\n' +
                '              </div>'
          },
          "ajax": {
            url: processingURL,
            type: "post",
            data: function (d) {
              if (user.userRolesById[0].role === "ROLE_USER" || user.userRolesById[0].role === 'ROLE_FRANCHISE') {
                Object.assign(d, {restaurant_id: user.restaurant.id});
              }
              if (user.userRolesById[0].role === "ROLE_BRANCH") {
                console.log('branch_user')
              }
              return JSON.stringify(d);
            },
            headers: {
              "Content-type": "application/json; charset=utf-8"
            },
            beforeSend: (xhr) => {
              xhr.setRequestHeader('Authorization', 'Bearer ' + this.$store.state.accessToken);
            },
            statusCode: {
              401: () => {
                this.updateRefreshTokenInDataTable(dtTable);
              }
            }
          },
          "columnDefs": [
            {"orderable": false, "targets": [0,1, 2, 3, 4, 7, 8]},
            {'className': "text-center", 'aTargets': [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]},
            { 'visible':  self.userRole === 'ROLE_ADMIN' || self.userRole === 'ROLE_USER' || self.userRole === 'ROLE_FRANCHISE' || self.userRole === 'ROLE_MANAGER', targets: [9]}
          ],
          "columns": [
            {"data": "id", "name": "id"},
            {"data": "name", "name": "name"},
            {
              "data": "contact", "name": "contact",
              "render": function(data, type, row) {
                if(row.contact === null || row.contact === ""){
                  return "N/A";
                }if(row.softDeleted){
                  return data.split("&")[0];
                }
                return data;
              }
            },
            {
              "data": "vehicleNumber", "name": "Vehicle Number",
              "render": function (data) {
                return (data === null) ? "N/A" : data;
              }
            },
            {
              "data": "contact", "name": "contact",
              "render": function (data) {
                return (data === null) ? "N/A" : data;
              }
            },
            {
              "data": "created",
              "name": "created",
              "render": function (data) {
                return "<span class='m_tip label label-default'>" + self.formatDate(String(data)) + "</span>";
              }
            },
            {
              "data": "modified",
              "name": "modified",
              "render": function (data) {
                return "<span class='m_tip label label-default'>" + self.formatDate(String(data)) + "</span>";
              }
            },
            {
              "data": "deleted",
              "name": "Deleted",
              "render": function (data) {
                if (!data) {
                  return "<label class='label label-success'>Yes</label>"
                } else {
                  return "<label class='label label-danger'>No</label>"
                }
              }
            },
            {
              "data": "contactNoVerified",
              "name": "verified",
              "render": function (data) {
                if (data) {
                  return "<label class='label label-success'>Yes</label>"
                } else {
                  return "<label class='label label-danger'>No</label>"
                }
              }
            },
            {
              "data": "action", "name": "action",
              "render": function (data, type, row) {
                  let actions = "";
                  actions += "<a data-id='" + row.id + "' class='deleteRiderBtn' ><i title='Delete Rider' class='fa fa-trash fa-lg'></i></a>|" +
                  "<a data-id='" + row.id + "' data-verified='" + row.contactNoVerified + "' class='enableRider'>" +
                  "<i title='" + ((row.deleted) ? 'Enable Rider' : 'Disable Rider') +
                  "' class='" + ((row.deleted) ? 'fa fa-check fa-lg' : 'fa fa-minus-circle fa-lg') + "'></i>" +
                  "</a>|" +
                  "<a data-id='" + row.id + "' class='updateRiderBtn'><i title='Update Rider' class='fa fa-pencil fa-lg'></i></a>|" +
                  "<a data-id='" + row.id + "'  data-name='" + row.name + "' class='viewRiderBranchBtn'><i title='Associated Branches' class='fa fa-gear fa-lg'></i></a>";
                return actions;
              }
            },
          ],
          "drawCallback": function () {
            $(".m_tip").tooltip();
            $(".updateRiderBtn").click(function () {
              let riderId = $(this).attr("data-id");
              self.$refs.addUpdateRiderPopUp.load(riderId, false);
            });
            $(".viewRiderBranchBtn").click(function () {
              let riderId = $(this).attr("data-id");
              let riderName = $(this).attr("data-name")
              self.$refs.viewAddUpdateRiderBranchesRef.load(riderId, riderName);
            });
            $(".enableRider").click(async function () {
              let riderId = $(this).attr("data-id");
              self.showLoading()
              let updateToggleRider = await toggleRider(riderId)
                  .catch(ex => {
                    self.showErrorMessage(ex)
                  })
              if(updateToggleRider.data !== undefined && updateToggleRider.data.status === 200){
                dtTable.draw();
                swal("SUCCESS!", updateToggleRider.data.message, "success")
              }else{
                self.showErrorMessage(updateToggleRider)
              }
            });
            $(".deleteRiderBtn").click(function () {
              let riderId = $(this).attr("data-id");
              Swal({
                title: 'Are you sure?',
                text: "Are you sure you want to delete this rider!",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#1ab394',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
              }).then(async (result) => {
                if (result.value) {
                  self.showLoading()
                  try {
                    let deleteRiderResp = await deleteRider(riderId)
                    if (deleteRiderResp.data !== undefined && deleteRiderResp.data.status === 200) {
                      swal("SUCCESS", "Successfully delete rider!", "success")
                      dtTable.draw();
                    } else {
                      self.showErrorMessage(deleteRiderResp)
                    }
                  }catch(ex) {
                    self.showErrorMessage(ex)
                  }
                }
              });
            });
          },
          "tableTools": {
            "sSwfPath": "js/plugins/dataTables/swf/copy_csv_xls_pdf.swf"
          }
        });
        this.table = dtTable;
        $.fn.dataTable.ext.errMode = 'none';
        $(".search_filter_order_btn").click(function () {
          dtTable.search('');
          dtTable.column(2).search($("#contact").val());
          dtTable.column(3).search($("#vehicle_number").val());
          dtTable.column(8).search(self.isVerified === 'All' ? '' : self.isVerified);
          dtTable.column(7).search(self.isEnabled === 'All' ? '' : self.isEnabled);
          dtTable.draw();
          self.branches = [];
        });
        $(".refresh_filter_order_btn").click(function () {
          dtTable.search('');
          dtTable.column(2).search('');
          dtTable.column(3).search('');
          dtTable.column(7).search('');
          dtTable.column(8).search('');
          dtTable.draw();
          $("#contact").val('')
          $("#vehicle_number").val('')
          self.isVerified = 'All';
          self.isEnabled = 'All';
        });
        let dtTableFilterSelector = $("#dtTable_filter input");
        dtTableFilterSelector.unbind();
        dtTableFilterSelector.attr("size", "35");
        dtTableFilterSelector.attr("placeholder", "Search On Name, branch, Vehicle No. or contact....");
        dtTableFilterSelector.keyup(function (e) {
          if (e.keyCode === 13) {
            dtTable.search($(this).val()).draw();
          }
        });
      },
      computed: {
        isBranchUser() {
          return this.$store.state.user.userRolesById && this.$store.state.user.userRolesById[0].role === 'ROLE_BRANCH'
        }
      },
      methods: {
        tableDraw: function () {
          this.table.draw()
        },
        redrawtable: function () {
          this.table.ajax.reload(null, false);
        },
        fetchBranchesOfRestaurant: function () {
          let params = new URLSearchParams();
          params.append("restaurant_id", this.selectedRestaurant.id);
          if (this.selectedRestaurant !== "all") {
            this.$http.post(this.$store.state.mainAppURL + "restaurants/get_all_branches", params).then(resp => {
              console.log(resp.data);
              this.branches = resp.data;
            });
          } else {
            this.selectedBranch = "all";
            this.branches = [];
          }
        },
        loadEmptyCustomer: function () {
          this.$refs.addUpdateRiderPopUp.load(0, false);
        }
      }
    }
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.disabled-icon {
  color: #8fcbff !important;
}
</style>
